import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import commonFormMeta from '@Shared/components/form/commonFormMeta';
import { capitalize } from '@Shared/utils/helpers';
import { getValidationSchema } from '@Shared/utils/validationSchema';
import * as yup from "yup";


export interface IClientFormMeta {
    merchantType: FormInputMeta;
    merchantID: FormInputMeta;
    companyName: FormInputMeta;
    DBAName: FormInputMeta;
    type: FormInputMeta;
    initialSolvencyLevel: FormInputMeta;
    city: FormInputMeta;
    // Identification
    licence: FormInputMeta;
    siretNumber: FormInputMeta;
    capital: FormInputMeta;
    tradeRegisterNumber: FormInputMeta;
    socialSecurityNumber: FormInputMeta;
    taxIdentificationNumber: FormInputMeta;
    //
    contractNumber: FormInputMeta;
    creationDate: FormInputMeta;
    signatureDate: FormInputMeta;
    
    schema: any;
  }

const ClientFormMeta = {} as IClientFormMeta;


ClientFormMeta.merchantType = {
  name: "merchantType",
  label: "Type commercant",
  type: "select",
  options:  [
      {
        label: 'Type commercant A',
        value: 'a'
      },
      {
        label: 'Type commercant B',
        value: 'b',
      },
      {
        label: 'Type commercant C',
        value: 'b',
      },
    ],
    validation: yup.string().required("Ce champ est requis"),
};

ClientFormMeta.merchantID = {
  name: 'merchantID',
  type: 'text',
  label: 'ID commercant',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

ClientFormMeta.companyName = {
  name: 'companyName',
  type: 'text',
  label: 'Raison sociale',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

ClientFormMeta.DBAName = {
  name: 'DBAName',
  type: 'text',
  label: 'Nom D/B/A',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
ClientFormMeta.type = {
  name: "type",
  label: "Type",
  type: "select",
  options:  [
      {
        label: 'Type A',
        value: 'a'
      },
      {
        label: 'Type B',
        value: 'b',
      },
      {
        label: 'Type C',
        value: 'b',
      },
    ],
    validation: yup.string().required("Ce champ est requis"),
};
ClientFormMeta.initialSolvencyLevel = {
  name: 'initialSolvencyLevel',
  type: 'text',
  label: 'Niveau de solvabilite Initial',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
ClientFormMeta.city = {
    name: "city",
    label: "Ville",
    type: "select",
    options:  [
        {
          label: 'Ville A',
          value: 'a'
        },
        {
          label: 'Ville B',
          value: 'b',
        },
        {
          label: 'Ville C',
          value: 'b',
        },
      ],
      validation: yup.string().required("Ce champ est requis"),
};

// Identification
ClientFormMeta.licence = {
  name: 'licence',
  type: 'text',
  label: 'Licence',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
ClientFormMeta.siretNumber = {
  name: 'siretNumber',
  type: 'text',
  label: 'Numero Siret',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
ClientFormMeta.capital = {
  name: 'capital',
  type: 'text',
  label: 'Capital',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
ClientFormMeta.tradeRegisterNumber = {
  name: 'tradeRegisterNumber',
  type: 'text',
  label: 'Numero registre commerce',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
ClientFormMeta.socialSecurityNumber = {
  name: 'socialSecurityNumber',
  type: 'text',
  label: 'Numero securite sociale',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
ClientFormMeta.taxIdentificationNumber = {
  name: 'taxIdentificationNumber',
  type: 'text',
  label: "Numero d'identification fiscale",
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
//
ClientFormMeta.contractNumber = {
  name: 'contractNumber',
  type: 'text',
  label: 'Numero contrat',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
ClientFormMeta.creationDate = {
  name: 'creationDate',
  type: 'date',
  label: 'Date creation',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
ClientFormMeta.signatureDate = {
  name: 'signatureDate',
  type: 'date',
  label: 'Date signature',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

ClientFormMeta.schema = yup.object().shape(getValidationSchema(ClientFormMeta));

export default ClientFormMeta;